'use client';
// Petites primitives partagées par les écrans « ressources & évaluation ».
//
// Ces cinq éléments vivaient en tête d'un fichier de 1 262 lignes qui portait à
// lui seul les équipements, le CQI, l'EEQ, l'organigramme, les habilitations, la
// cartographie et la vue auditeur. Deux chantiers simultanés dessus se
// marchaient dessus — d'où le découpage en un écran par fichier.
import React from 'react';
import { TitrePage, styleRubrique } from '@/components/ui';

export type ProcRow = { id: string; name: string; group: string; active: boolean; code?: string; codif?: string; pilote?: string; suppleant?: string; piloteFonction?: string; suppleantFonction?: string; note?: string };
export const initials = (nom: string) => nom.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]?.toUpperCase() || '').join('') || '??';

/** L'intitulé de rubrique. Les valeurs vivent dans `styleRubrique`
 *  (`components/ui`) — sept définitions concurrentes avaient été relevées le
 *  26/08/2026. `lbl` reste exporté : 47 fichiers l'emploient, et le renommer
 *  n'aurait rien corrigé. */
export const lbl: React.CSSProperties = styleRubrique;
export const pill = (m: { label: string; bg: string; fg: string }) => (
  <span style={{ display: 'inline-flex', padding: '2px 9px', borderRadius: 'var(--radius-pill)', background: m.bg, color: m.fg, fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap' }}>{m.label}</span>
);
// `eyebrow` accepte du JSX pour porter une référence normative glosée (RefISO).
export const H1 = ({ eyebrow, title }: { eyebrow: React.ReactNode; title: string }) => (
  <TitrePage eyebrow={eyebrow} titre={title} />
);
